import React from "react"
import { Container, Dimmer, Loader as SLoader, Segment } from "semantic-ui-react"
import { withTranslation, WithTranslation } from 'react-i18next'

function ConfigLoader({ message, t }) {
    return (
        <Dimmer active inverted>
            <SLoader>{message}</SLoader>
        </Dimmer>
    )
}

export default withTranslation()(ConfigLoader)